<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="manufacturerSelectItems"
            v-model="item.manufacturer"
            :items="manufacturerSelectItems"
            :error-messages="manufacturerErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.nozzle.manufacturer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleInSelectItems"
            v-model="item.nozzleIn"
            :items="nozzleInSelectItems"
            :error-messages="nozzleInErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.nozzle.nozzlesin')"
            item-text="size"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleOutSelectItems"
            v-model="item.nozzleOut"
            :items="nozzleOutSelectItems"
            :error-messages="nozzleOutErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.nozzle.nozzlesout')"
            item-text="size"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSelectItems"
            v-model="item.material"
            :items="filteredMaterialSelectItems"
            :error-messages="materialErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.nozzle.material')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="typeSelectItems"
            v-model="item.type"
            :items="typeSelectItems"
            :error-messages="typeErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.nozzle.type')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="visualSelectItems"
            v-model="item.visual"
            :items="visualSelectItems"
            :error-messages="visualErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.nozzle.visual')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'NozzleForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.manufacturerGetSelectItems();
      this.nozzleInGetSelectItems();
      this.nozzleOutGetSelectItems();
      this.materialGetSelectItems();
      this.typeGetSelectItems();
      this.visualGetSelectItems();
  },
  data() {
    return {
        manufacturer: null,
        nozzleIn: null,
        nozzleOut: null,
        material: null,
        type: null,
        visual: null,
        archuive: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_nozzlemanufacturer ||
           this.isLoading_nozzlein ||
           this.isLoading_nozzleout ||
           this.isLoading_nozzlematerial ||
           this.isLoading_nozzletype ||
           this.isLoading_nozzlevisual 
         );
      },
      ...mapFields('nozzlemanufacturer', {
        manufacturerSelectItems: 'selectItems',
        isLoading_nozzlemanufacturer : 'isLoading'
      }),
      ...mapFields('nozzlein', {
        nozzleInSelectItems: 'selectItems',
        isLoading_nozzlein : 'isLoading'
      }),
      ...mapFields('nozzleout', {
        nozzleOutSelectItems: 'selectItems',
        isLoading_nozzleout : 'isLoading'
      }),
      ...mapFields('nozzlematerial', {
        materialSelectItems: 'selectItems',
        isLoading_nozzlematerial : 'isLoading'
      }),
      ...mapFields('nozzletype', {
        typeSelectItems: 'selectItems',
        isLoading_nozzletype : 'isLoading'
      }),
      ...mapFields('nozzlevisual', {
        visualSelectItems: 'selectItems',
        isLoading_nozzlevisual : 'isLoading'
      }),

      filteredMaterialSelectItems() {
        return this.materialSelectItems.filter(material => !material.archive);
      },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    manufacturerErrors() {
      const errors = [];

      if (!this.$v.item.manufacturer.$dirty) return errors;

      has(this.violations, 'manufacturer') && errors.push(this.violations.manufacturer);


      return errors;
    },
    nozzleInErrors() {
      const errors = [];

      if (!this.$v.item.nozzleIn.$dirty) return errors;

      has(this.violations, 'nozzleIn') && errors.push(this.violations.nozzleIn);


      return errors;
    },
    nozzleOutErrors() {
      const errors = [];

      if (!this.$v.item.nozzleOut.$dirty) return errors;

      has(this.violations, 'nozzleOut') && errors.push(this.violations.nozzleOut);


      return errors;
    },
    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.material);


      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);


      return errors;
    },
    visualErrors() {
      const errors = [];

      if (!this.$v.item.visual.$dirty) return errors;

      has(this.violations, 'visual') && errors.push(this.violations.visual);


      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        manufacturerGetSelectItems: 'nozzlemanufacturer/fetchSelectItems'
      }),
      ...mapActions({
        nozzleInGetSelectItems: 'nozzlein/fetchSelectItems'
      }),
      ...mapActions({
        nozzleOutGetSelectItems: 'nozzleout/fetchSelectItems'
      }),
      ...mapActions({
        materialGetSelectItems: 'nozzlematerial/fetchSelectItems'
      }),
      ...mapActions({
        typeGetSelectItems: 'nozzletype/fetchSelectItems'
      }),
      ...mapActions({
        visualGetSelectItems: 'nozzlevisual/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      manufacturer: {
      },
      nozzleIn: {
      },
      nozzleOut: {
      },
      material: {
      },
      type: {
      },
      visual: {
      },
      archive: {
        
      },
    }
  }
};
</script>
